<ng-container *ngIf="benefitPlan?.benefitPolicy?.hasEnhancedManagedBenefits">
    <form #form="ngForm">
        <div class="app-grid margin-bottom-1">
            <mat-form-field class="columns-12">
                <mat-label appRemoveAriaOwns>Division</mat-label>
                <mat-select name="division" #division="ngModel" [(ngModel)]="selectedBenefitDivision" required>
                    <mat-option *ngFor="let division of benefitPlan.benefitPolicy.divisions" [value]="division">{{
                        division.name
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="division.invalid">{{ division.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-radio-group
                aria-label="Would you like to waive the waiting period for selected employees?"
                name="waiveWaitingPeriod"
                [(ngModel)]="waiveWaitingPeriod"
                required
            >
                <mat-label> Would you like to waive the waiting period for selected employees? </mat-label>
                <div>
                    <mat-radio-button [value]="false" checked>No</mat-radio-button>
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                </div>
            </mat-radio-group>
        </div>
    </form>
</ng-container>
